import { type CustomIntegrationAuthType } from '../../../models/CustomIntegration'
import { type AuthFormState, type DetailsFormData } from './customIntegrationForm'

const trimmed = (value: string): string => value.trim()

export const detailsChangeInvalidatesCredentials = (initial: DetailsFormData, current: DetailsFormData): boolean =>
  trimmed(initial.endpointUrl) !== trimmed(current.endpointUrl)

export const authChangeInvalidatesCredentials = (
  initialType: CustomIntegrationAuthType,
  initialForms: AuthFormState,
  type: CustomIntegrationAuthType,
  forms: AuthFormState,
): boolean => {
  if (type !== initialType) {
    return true
  }
  if (type !== 'oauth2') {
    return false
  }
  const before = initialForms.oauth2
  const after = forms.oauth2
  return (
    trimmed(after.clientSecret) !== '' ||
    trimmed(before.clientId) !== trimmed(after.clientId) ||
    trimmed(before.authorizationUrl) !== trimmed(after.authorizationUrl) ||
    trimmed(before.tokenUrl) !== trimmed(after.tokenUrl) ||
    before.scopes.join(' ') !== after.scopes.join(' ')
  )
}
